import { defer, map } from 'rxjs';
import type { Observable } from 'rxjs';
import { geolocationList } from 'services/api/geolocation/geolocation';
import filterWhileNullish from 'utils/rxjs/filter-while-nullish';
import progressiveRetry from 'utils/rxjs/progressive-retry';
import type { GeoIpRecordResponse } from 'services/api/geolocation/data-contracts';
import type { DeepRequired } from 'contracts';

import Store from './store';
import notifyUserOnError from './utils/notify-user-on-error';

type GeolocationStore = Exclude<DeepRequired<GeoIpRecordResponse>, undefined>;

class Geolocation extends Store<GeolocationStore | undefined> {
  source$ = defer(() => {
    // flags store as loading
    super.meta.setLoading(true);

    return geolocationList();
  }).pipe(
    progressiveRetry(),
    notifyUserOnError({ type: 'error', message: 'request-failed', onClick: () => this.reset() }),
    map((response) => response.data as GeolocationStore)
  );

  constructor() {
    super({ name: 'geolocation', initialState: undefined });
  }

  /**
   * On Geolocation Data change.
   * @description Event stream to get notified when Geolocation Data changes.
   * It does not emit when data is nullish.
   */
  get onChange$(): Observable<GeolocationStore> {
    return super.onChange$.pipe(filterWhileNullish());
  }
}

export type { GeolocationStore };
export default new Geolocation();
